import { BOOKING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

export interface IEroorMessage {
  status: boolean;
  message: string;
}

export const useUserBookingsWhatsappScriptDetailsAPI = () => {
  const configuration = useConfiguration();
  const [userDetails, setUserDetails] = useState(null);
  const dispatch = useAppDispatch();

  const execute = useCallback(
    async (bookingId: string): Promise<IEroorMessage> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: IEroorMessage = await axios
          .get(`${BOOKING_APIS?.SEND_SCRIPT?.baseURL}?booking_id=${bookingId}` ?? "", {
            headers: {
              Authorization: `${accessToken}`,
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status) {
              setUserDetails(res.data.data);
              return { status: true, message: res.data?.message };
            } else {
              setUserDetails(null);
              toast.error("Script Details Fetch Failed ");
              return { status: false, message: res.data?.message };
            }
          })
          .catch((e: AxiosError) => {
            setUserDetails(null);
            toast.error("Script Details Fetch Failed ");
            return { status: false, message: "" };
          });

        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return { status: false, message: "" };
      }
    },
    [dispatch],
  );

  return { execute, userDetails };
};
